import { render, staticRenderFns } from "./logoutIOS.vue?vue&type=template&id=52b9f19c&scoped=true&"
import script from "./logoutIOS.vue?vue&type=script&lang=js&"
export * from "./logoutIOS.vue?vue&type=script&lang=js&"
import style0 from "./logoutIOS.vue?vue&type=style&index=0&id=52b9f19c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9f19c",
  null
  
)

export default component.exports